import script from "./SelectInputMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInputMultiple.vue?vue&type=script&setup=true&lang=js"

import "./SelectInputMultiple.vue?vue&type=style&index=0&id=7276182d&lang=css"

const __exports__ = script;

export default __exports__